// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__xNQQP","footer":"ModalUpdate_footer__11X2W"};